import '@fontsource-variable/archivo';
import './styles/tokens.css';
import './styles/base.css';

import { createPinia } from 'pinia';
import { registerSW } from 'virtual:pwa-register';
import { createApp, watch } from 'vue';

import App from './App.vue';
import i18n from './i18n';
import router from './router';
import { useUiStore } from './stores/ui';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);

// La lingua vive nello store (che la persiste) ma è vue-i18n a usarla:
// si tengono allineati in un punto solo.
const ui = useUiStore();
if (ui.locale) {
  i18n.global.locale.value = ui.locale;
} else {
  ui.locale = i18n.global.locale.value;
}
watch(
  () => ui.locale,
  (value) => {
    if (value) {
      i18n.global.locale.value = value;
      document.documentElement.lang = value;
    }
  },
  { immediate: true },
);

/* Il gancio per il guscio: la colonna gemella nel feed (bridge) chiede al
 * Rust di portare l'archivio su una board, e il Rust chiama questo invece di
 * ricaricare la pagina — è il router, quindi il cambio è istantaneo. Esiste
 * solo dentro l'app: nel browser nessuno lo chiama. */
if (typeof window !== 'undefined' && window.__TAURI_INTERNALS__) {
  window.__bachecaVai = (percorso) => router.push(percorso);
}

app.mount('#app');

/* --- Aggiornamento della versione servita ------------------------------
 *
 * Il service worker risponde alle NAVIGAZIONI con l'index.html precachato,
 * non con quello del server: dopo un rilascio la finestra continua a mostrare
 * la versione vecchia finché un worker nuovo non ha finito di installarsi, e
 * la si riapre. Se l'app viene chiusa prima che finisca, il lavoro ricomincia
 * da capo — e la versione vecchia può restare lì per sempre, facendo credere
 * che il rilascio non sia mai avvenuto.
 *
 * Il registratore iniettato dal plugin si limitava a registrare il worker,
 * senza mai ricaricare. Qui invece il worker nuovo viene applicato appena è
 * pronto e la pagina si ricarica da sé: niente doppia riapertura, e nessuna
 * finestra che resta indietro. */
const applicaAggiornamento = registerSW({
  immediate: true,
  onRegisteredSW(_url, registrazione) {
    // Un controllo ogni dieci minuti: la finestra dell'archivio resta aperta
    // per giorni, e senza questo si accorgerebbe di un rilascio solo al
    // prossimo avvio.
    if (registrazione) setInterval(() => registrazione.update(), 10 * 60 * 1000);
  },
  onNeedRefresh() {
    applicaAggiornamento(true);
  },
});

/* La ricarica vera. `controllerchange` scatta quando il worker nuovo prende
 * il posto del vecchio: da quel momento la pagina è mezza vecchia e mezza
 * nuova, e va riletta. Il guardiano evita il ciclo infinito — al primissimo
 * avvio il worker prende il controllo di una pagina che è già l'ultima
 * versione, e ricaricare all'infinito sarebbe peggio del problema. */
if ('serviceWorker' in navigator) {
  let giaRicaricata = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (giaRicaricata) return;
    giaRicaricata = true;
    window.location.reload();
  });
}
